import axios from '../config/axios'

export const getParticipant = ()=> axios.get('/participant')
export const putAgreeNda = ()=> axios.put('/participant/activity/agreeNda')